<template>
	<div class="main">
		<div class="login_win" id="loginWindow">
			<TipsWindow ref="tips"></TipsWindow>
			<img class="close b-close" src="../assets/image/close.png" alt="">
			<img class="logo_img" :src="gameData.logoImage" alt="">
			<div class="user_login">
				<div class="login_phone">
					<i class="fa fa-user color"></i>
					<input type="user" v-model="loginId" @keyup.enter="login" :placeholder="$t('account_input_text')">
				</div>
				<div class="login_account">
					<i class="fa fa-lock color"></i>
					<input type="password" v-model="password" @keyup.enter="login" :placeholder="$t('password_input_text')">
				</div>
			</div>
			<button :class="['login_button', 'bg_color', buttonIsActive ? 'button_active' : '']"
				:disabled="buttonDisabled" v-on:click="login()">{{ loginButtonText }}</button>

			<!-- <p class="forgot">비밀번호 찾기</p> -->
			<p class="methods">—— {{ $t('other_login_methods_text') }} ——</p>
			<div class="third_party">
				<div class="fb_login_button" v-on:click="initFacebookPlugin()"></div>
				<div id="googleLogin"></div>
			</div>
			<!-- <div class="login_check">
        <input type="checkbox" checked="">
        <div style="display: flex;position: absolute;margin-left: 14px;">
          <a href="" style="text-decoration: underline;">Privacy Policy and Terms </a>
          <span> &nbsp;Read and Agree.</span>
        </div>
      </div> -->
		</div>
	</div>
</template>

<script>
	import $ from 'jquery'
	import axios from 'axios'
	import md5 from 'js-md5';
	import {
		isNotEmpty,
		Base64,
		getGoogleAppClientId
	} from '../utils/index.js'
	import TipsWindow from '../components/tipsWindow.vue'
	export default {
		name: 'loginWindow',
		components: {
			TipsWindow
		},
		data() {
			return {
				loginId: '',
				password: '',
				loginButtonText: this.$i18n.tc("login_button_text"),
				buttonIsActive: false,
				buttonDisabled: false,
				timerIndex: -1,
				gameData: this.$store.state.gameData
			}
		},
		mounted() {
			this.initGooglePlugin();
		},
		methods: {
			login: function() {
				this.buttonIsActive = true;
				this.loginButtonProgressBar('start');
				this.loginHandle();
			},
			initFacebookPlugin: function() {
				FB.init({
					appId: this.gameData.fbAppId,
					autoLogAppEvents: true,
					xfbml: true,
					cookie: true,
					version: 'v8.0'
				});
				let _this = this;
				FB.getLoginStatus(function(response) {
					if (response.status === 'connected') {
						_this.facebookLoginHandle(response);
					} else {
						FB.login(function(response) {
							if (response.status === 'connected') {
								_this.facebookLoginHandle(response);
							}
						})
					}
				});
			},
			initGooglePlugin: function() {
				let _this = this;
				const googleLoginEl = document.getElementById("googleLogin");
      			if (!googleLoginEl) return;
				googleLoginEl.innerHTML = '';
				google.accounts.id.cancel();
				google.accounts.id.initialize({
					client_id: getGoogleAppClientId(this.gameData.env),
					prompt_parent_id: 'googleLogin',
					callback: function(response) {
						_this.googleLoginHandle(response, _this)
					}
				});
				google.accounts.id.renderButton(
					document.getElementById("googleLogin"), {
						theme: "outline",
						size: "large",
						type: "icon",
						shape: "rectangular"
					}
				);
				google.accounts.id.prompt();
			},
			loginHandle: function() {
				this.$analytics.track('login_submitted', { login_method: 'password' });
				let loginPassword = this.password.length >= 32 ? this.password : md5(this.password);
				this.$axios({
						method: 'get',
						url: '/web/api/member/login',
						params: {
							loginId: this.loginId,
							password: loginPassword,
							gameCode: this.gameData.gameCode,
							gameLanguage: this.gameData.language
						}
					})
					.then(response => {
						if (response.code === 1000) {
							this.$cache.clearAllCacheData();
							this.$session.setLoginDataToCookie(response.data);
							this.$analytics.track('login_succeeded', { login_method: 'password' });
							this.$analytics.flush();
							this.$cache.setLoginData(response.data);
							window.location.reload();
						} else {
							this.$refs.tips.show(response.message, 'error');
							this.loginButtonProgressBar('stop');
							this.$analytics.track('login_failed', { login_method: 'password', reason: 'business_rejected', error_code: response.code });
						}
					})
					.catch(error => {
						this.$analytics.track('login_failed', { login_method: 'password', reason: 'network_error' });
						this.loginButtonProgressBar('stop');
					});
			},
			googleLoginHandle: function(response, _this) {
				this.$analytics.track('login_submitted', { login_method: 'google' });
				let credential = response.credential;
				let payloadBase64 = credential.split('.')[1];
				payloadBase64 = payloadBase64.replace(/-/g, '+').replace(/_/g, '/');
				let googleUser = JSON.parse(Base64.decode(payloadBase64));
				if (isNotEmpty(googleUser.sub)) {
					this.$axios({
							method: 'get',
							url: '/web/api/google/login',
							params: {
								googleUserId: googleUser.sub,
								googleClientId: getGoogleAppClientId(this.gameData.env),
								googleIdToken: credential,
								gameCode: this.gameData.gameCode,
								gameLanguage: this.gameData.language
							}
						})
						.then(response => {
							if (response.code === 1000) {
								_this.$cache.clearAllCacheData();
								_this.$session.setLoginDataToCookie(response.data);
								_this.$analytics.track('login_succeeded', { login_method: 'google' });
								_this.$analytics.flush();
								_this.$cache.setLoginData(response.data);
								window.location.reload();
							} else {
								_this.$refs.tips.show(response.message, 'error');
								_this.$analytics.track('login_failed', { login_method: 'google', reason: 'business_rejected', error_code: response.code });
							}
						}).catch(() => {
							_this.$analytics.track('login_failed', { login_method: 'google', reason: 'network_error' });
						})
				}

			},
			facebookLoginHandle: function(response) {
				this.$analytics.track('login_submitted', { login_method: 'facebook' });
				if (isNotEmpty(response)) {
					this.$axios({
							method: 'get',
							url: '/web/api/fb/login',
							params: {
								gameCode: this.gameData.gameCode,
								fbUserId: response.authResponse.userID,
								fbOauthToken: response.authResponse.accessToken,
								gameLanguage: this.gameData.language,
								gameCode: this.gameData.gameCode,
							}
						})
						.then(response => {
							if (response.code === 1000) {
								this.$cache.clearAllCacheData();
								this.$session.setLoginDataToCookie(response.data);
								this.$analytics.track('login_succeeded', { login_method: 'facebook' });
								this.$analytics.flush();
								this.$cache.setLoginData(response.data);
								window.location.reload();
							} else {
								this.$refs.tips.show(response.message, 'error');
								this.$analytics.track('login_failed', { login_method: 'facebook', reason: 'business_rejected', error_code: response.code });
							}
						}).catch(() => {
							this.$analytics.track('login_failed', { login_method: 'facebook', reason: 'network_error' });
						})
				}

			},
			loginButtonProgressBar: function(task) {
				let _this = this;
				if (task === 'start') {
					let textSuffix = "";
					let buttonText = this.$i18n.tc("logining_button_text");
					this.buttonDisabled = true;
					this.loginButtonText = buttonText;
					this.timerIndex = setInterval(function() {
						if (textSuffix.length === 3) {
							textSuffix = "";
						} else {
							textSuffix += ".";
						}
						_this.loginButtonText = buttonText + textSuffix;
					}, 500)
				} else {
					clearInterval(this.timerIndex);
					this.buttonIsActive = false;
					this.buttonDisabled = false;
					this.loginButtonText = this.$i18n.tc("login_button_text");
				}

			}
		}
	}
</script>
<style scoped>
	@import 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css';
</style>
